<template>
  <v-card>
    <v-form @submit.prevent="submitAddRate()" ref="addRateForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 class="flex-container-space-between">
            <span class="headline">
              Add rate
              <span class="grey--text subheading"></span>
            </span>
            <div>
              <v-switch
                :color="primaryNeutral"
                class="mt-0"
                label="Active rate"
                v-model="rate.active"
              ></v-switch>
            </div>
          </v-flex>
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">
              Master Files
              <span class="caption font-italic">(At least one required) *</span>
            </div>
          </v-flex>
          <v-flex xs12 sm6 v-for="(item, i) in autoCompletes" :key="i">
            <v-autocomplete
              :label="item.label"
              :items="$store.state[item.items][item.items]"
              :prepend-icon="$store.state.global.pages[item.page].icon"
              :item-text="item.itemText"
              item-value="id"
              :rules="rules[`${item.page}Rules`]"
              v-model="rate[item.value]"
              no-data-text="No data found"
              :color="primaryNeutral"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-expansion-panel expand class="grey lighten-3">
              <v-expansion-panel-content class="grey lighten-4">
                <div
                  slot="header"
                  class="font-weight-medium grey--text text--darken-2 vertical-center-container"
                >
                  <v-icon
                    :color="$store.state.global.pages.vehicleType.color"
                    class="mr-2"
                  >{{$store.state.global.pages.vehicleType.icon}}</v-icon>Selected Vehicles
                </div>

                <v-list subheader>
                  <v-list-tile
                    v-for="item in $store.state.vehicleTypes.vehicleTypes"
                    :key="item.id"
                    fluid
                  >
                    <v-checkbox
                      v-model="rate.selectedVehicleTypes"
                      :label="item.name_tonnage"
                      :value="item"
                    ></v-checkbox>
                  </v-list-tile>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>

          <!-- STANDARD COST -->
          <!-- STANDARD COST -->
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">Cost</div>
          </v-flex>
          <v-flex xs6 class="flex-container-space-between">
            <!-- <span class="pt-4 pr-3">Cost: </span>  -->
            <v-text-field
              type="number"
              label="* Cost price"
              :rules="priceRules"
              v-model="rate.costPrice"
              prepend-icon="attach_money"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="flex-container-space-between">
            <span class="pt-4 pr-3">/</span>
            <v-autocomplete
              label="Cost unit"
              :items="units"
              v-model="rate.costUnit"
              no-data-text="An error occured"
              :color="primaryNeutral"
            ></v-autocomplete>
          </v-flex>

          <!-- STANDARD SELL -->
          <!-- STANDARD SELL -->
          <v-flex xs12>
            <div class="body-2 grey--text text--darken-1">Sell</div>
          </v-flex>
          <v-flex xs6 class="flex-container-space-between">
            <!-- <span class="pt-4 pr-3">Sell: </span>  -->
            <v-text-field
              type="number"
              label="* Sell price"
              :rules="priceRules"
              v-model="rate.sellPrice"
              prepend-icon="attach_money"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="flex-container-space-between">
            <span class="pt-4 pr-3">/</span>
            <v-autocomplete
              label="Sell unit"
              :items="units"
              v-model="rate.sellUnit"
              no-data-text="An error occured"
              :color="primaryNeutral"
            ></v-autocomplete>
          </v-flex>

          <!-- RATE OPTIONS -->
          <!-- RATE OPTIONS -->
          <v-flex xs12 sm4 class="flex-container-space-between">
            <v-text-field
              type="number"
              label="Alt. Rate Trips"
              hint="This setting affects docket imports only"
              :color="primaryNeutral"
              v-model="rate.altRateTrips"
              :rules="altRateTripsRules"
              prepend-icon="calendar_today"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-switch
              :color="primaryNeutral"
              label="Admin fee required"
              v-model="rate.adminFeeRequired"
            ></v-switch>
          </v-flex>
          <v-flex xs12 sm4 class="vertical-center-container">
            <v-switch
              :color="primaryNeutral"
              class="mt-0"
              label="Use Vehicle Type tonnage"
              v-model="rate.useTonnage"
            ></v-switch>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Notes"
              prepend-icon="note"
              :rules="notesRules"
              v-model="rate.notes"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>

          <!-- ALTERNATE COST -->
          <!-- ALTERNATE COST -->
          <v-flex xs12>
            <v-expansion-panel expand class="mb-3">
              <v-expansion-panel-content class="grey lighten-5">
                <div
                  slot="header"
                  class="font-weight-medium grey--text text--darken-2 vertical-center-container"
                >
                  <v-icon color="orange" class="mr-2">access_time</v-icon>Alternate Rate
                </div>
                <form-container class="pl-2 pr-2">
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Alternate Cost</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Alt. Cost price"
                      :color="primaryNeutral"
                      v-model="rate.costPriceAlt"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-autocomplete
                      label="Cost unit Alt"
                      :items="units"
                      v-model="rate.costUnitAlt"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Alternate Sunday Cost</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Alt. Sunday Cost price"
                      :color="primaryNeutral"
                      v-model="rate.costPriceAltSunday"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-autocomplete
                      label="Cost unit Alt"
                      disabled
                      :items="units"
                      v-model="rate.costUnitAlt"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Alternate Sell</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Alt. Sell price"
                      :color="primaryNeutral"
                      v-model="rate.sellPriceAlt"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-autocomplete
                      label="Sell unit Alt"
                      :items="units"
                      v-model="rate.sellUnitAlt"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Alternate Sunday Sell</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Alt. Sunday Sell price"
                      :color="primaryNeutral"
                      v-model="rate.sellPriceAltSunday"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-autocomplete
                      label="Sell unit Alt"
                      disabled
                      :items="units"
                      v-model="rate.sellUnitAlt"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                </form-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-spacer></v-spacer>

            <!-- NIGHT RATE -->
            <!-- NIGHT RATE -->
            <v-expansion-panel expand class="mb-3">
              <v-expansion-panel-content class="grey lighten-5">
                <div
                  slot="header"
                  class="font-weight-medium grey--text text--darken-2 vertical-center-container"
                >
                  <v-icon color="blue darken-4" class="mr-2">alarm_off</v-icon>Night Rate
                </div>
                <form-container class="pl-2 pr-2">
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Cost</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Cost price"
                      :color="primaryNeutral"
                      v-model="rate.costPriceNight"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <span class="pt-4 pr-3">/</span>
                    <v-autocomplete
                      label="Cost unit"
                      :items="units"
                      v-model="rate.costUnitNight"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Sell</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Sell price"
                      :color="primaryNeutral"
                      v-model="rate.sellPriceNight"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <span class="pt-4 pr-3">/</span>
                    <v-autocomplete
                      label="Sell unit"
                      :items="units"
                      v-model="rate.sellUnitNight"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                </form-container>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- SUNDAY RATE -->
            <!-- SUNDAY RATE -->
            <v-expansion-panel expand class="mb-1">
              <v-expansion-panel-content class="grey lighten-5">
                <div
                  slot="header"
                  class="font-weight-medium grey--text text--darken-2 vertical-center-container"
                >
                  <v-icon color="blue" class="mr-2">weekend</v-icon>Sunday Rate
                </div>
                <form-container class="pl-2 pr-2">
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Cost</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Cost price"
                      :color="primaryNeutral"
                      v-model="rate.costPriceSunday"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <span class="pt-4 pr-3">/</span>
                    <v-autocomplete
                      label="Cost unit"
                      :items="units"
                      v-model="rate.costUnitSunday"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <div class="body-2 grey--text text--darken-1">Sell</div>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <v-text-field
                      type="number"
                      label="* Sell price"
                      :color="primaryNeutral"
                      v-model="rate.sellPriceSunday"
                      :rules="priceRules"
                      prepend-icon="attach_money"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="flex-container-space-between">
                    <span class="pt-4 pr-3">/</span>
                    <v-autocomplete
                      label="Sell unit"
                      :items="units"
                      v-model="rate.sellUnitSunday"
                      no-data-text="An error occured"
                      :color="primaryNeutral"
                    ></v-autocomplete>
                  </v-flex>
                </form-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn :color="primaryNeutral" flat type="submit" :loading="addingRate">Add</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RateService from "@/services/requests/rateService";
import ProjectService from "@/services/requests/projectService";
import SiteService from "@/services/requests/siteService";
import TipService from "@/services/requests/tipService";
import SpoilService from "@/services/requests/spoilService";
import VehicleService from "@/services/requests/vehicleService";
import RateValidation from "@/services/validation/rateValidation";

import FilterTipSpoils from "@/services/mixins/filterTipSpoils";

import getProjects from "@/services/mixins/getMasterFiles/getProjects";
import getSites from "@/services/mixins/getMasterFiles/getSites";
import getTips from "@/services/mixins/getMasterFiles/getTips";
import getSpoils from "@/services/mixins/getMasterFiles/getSpoils";
import getVehicleTypes from "@/services/mixins/getMasterFiles/getVehicleTypes";

export default {
  mixins: [
    RateValidation,
    FilterTipSpoils,
    getProjects,
    getSites,
    getTips,
    getSpoils,
    getVehicleTypes
  ],
  props: {
    parentStore: {
      type: String,
      default: "rates"
    }
  },
  data() {
    return {
      rate: {
        active: true,
        costUnit: "TONNE",
        costPrice: 0,
        costUnitAlt: "HOUR",
        costUnitNight: "TONNE",
        costPriceNight: 0,
        costPriceAlt: 0,
        costPriceAltSunday: 0,
        costUnitSunday: "TONNE",
        costPriceSunday: 0,
        costOT: 0,
        sellUnit: "TONNE",
        sellPrice: 0,
        sellUnitAlt: "HOUR",
        sellUnitNight: "TONNE",
        sellPriceNight: 0,
        sellUnitSunday: "TONNE",
        sellPriceAlt: 0,
        sellPriceAltSunday: 0,
        sellPriceSunday: 0,
        sellOT: 0,
        useTonnage: false,
        OTStart: "",
        OTEnd: "",
        notes: "",
        projectId: null,
        siteId: null,
        spoilId: null,
        tipId: null,
        vehicleTypeId: null,
        vehicleTypeIds: [],
        selectedVehicleTypes: [],
        adminFeeRequired: true,
        adminFeePercentage: 0,
        sellPriceTravelBreaks: 0,
        altRateTrips: 0
      },
      addingRate: false,
      color: "blue",
      units: ["TONNE", "HOUR", "DAY", "EA"],
      loading: false,
      //type: 'add'
      prefix: "rate",
      autoCompletes: [
        {
          label: "* Project",
          value: "projectId",
          items: "projects",
          page: "project",
          itemText: "name"
        },
        {
          label: "Site",
          value: "siteId",
          items: "sites",
          page: "site",
          itemText: "siteName_projectName"
        },
        {
          label: "Spoil",
          value: "spoilId",
          items: "spoils",
          page: "spoil",
          itemText: "name"
        },
        {
          label: "Tip",
          value: "tipId",
          items: "tips",
          page: "tip",
          itemText: "name"
        }
        // {
        //     label: 'Vehicle Type',
        //     value: 'vehicleTypeId',
        //     items: 'vehicleTypes',
        //     page: 'vehicleType',
        //     itemText: 'name_tonnage'
        // }
      ]
    };
  },
  methods: {
    submitAddRate() {
      if (!this.$refs.addRateForm.validate()) {
        this.snack({ text: "Please correct form errors", color: "red" });
        return;
      }
      this.rate.vehicleTypeIds = this.rate.selectedVehicleTypes.map(
        vehicleType => vehicleType.id
      );
      this.addRate();
    },
    addRate() {
      this.addingRate = true;
      RateService.addRate(this.rate)
        .then(result => {
          console.log(result.data.result);
          this.addingRate = false;
          result.data.result.new = true;
          this.$store.commit("rates/addToArrayState", {
            prop: "rates",
            value: result.data.result.rate
          });
          this.resetForm();
          this.snack({ text: "Rate was added!", color: "green" });
          this.close();
        })
        .catch(err => {
          this.snackError();
          this.addingRate = false;
          console.log(err);
        });
    },
    resetForm() {
      this.rate.notes = "";
      //this.rate.projectId = null;
      //this.rate.siteId = null;
      //this.rate.spoilId = null;
      //this.rate.tipId = null;
      this.rate.vehicleTypeId = null;
      this.rate.useTonnage = false;
      //this.rate.costUnit = "TONNE";
      this.rate.costPrice = 0;
      this.rate.costPriceAlt = 0;
      this.rate.costPriceAltSunday = 0;
      //this.rate.costUnitNight = "TONNE";
      this.rate.costPriceNight = 0;
      //this.rate.costUnitSunday = "TONNE";
      this.rate.costPriceSunday = 0;
      this.rate.selectedVehicleTypes = [];
      //this.rate.sellUnit = "TONNE";
      this.rate.sellPrice = 0;
      //this.rate.sellUnitNight = "TONNE";
      this.rate.sellPriceNight = 0;
      //this.rate.sellUnitSunday = "TONNE";
      this.rate.sellPriceSunday = 0;
      this.adminFeeRequired = true;

      this.$refs.addRateForm.resetValidation();
    },
    close() {
      this.$emit("close");
    },
    filterByProject(list, projectId) {
      return list.filter(record => {
        return record.projectId == projectId;
      });
    }
  },
  computed: {
    filteredSites() {
      if (!!this.rate.projectId) {
        return this.filterByProject(this.sites, this.rate.projectId);
      } else {
        return this.sites;
      }
    }
  },
  mounted() {}
};
</script>

<style>
</style>
